import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-2">
        <span className="font-bold text-lg text-gray-800 pr-4" data-id="element-3">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-4">
          <ChevronDown className="w-6 h-6 text-[#D4915D] flex-shrink-0" data-id="element-5" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-6">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-7">
            <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-8">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}